/**
 * @generated SignedSource<<6d53c24ccb72cd51e00254e007bfe88f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Locale = "EN" | "LT";
export type UpdateRoomInput = {
  capacity?: number | null;
  descriptionText?: TextBlockInput | null;
  name?: TextTranslationInput | null;
  properties?: ReadonlyArray<SetEntityInput> | null;
};
export type TextTranslationInput = {
  translations: ReadonlyArray<TranslationInput>;
};
export type TranslationInput = {
  locale: Locale;
  string?: string | null;
};
export type TextBlockInput = {
  blocks: ReadonlyArray<BlockInput>;
};
export type BlockInput = {
  data: string;
  locale: Locale;
};
export type SetEntityInput = {
  id: string;
};
export type RoomEditMainMutation$variables = {
  id: string;
  input: UpdateRoomInput;
};
export type RoomEditMainMutation$data = {
  readonly updateRoom: {
    readonly " $fragmentSpreads": FragmentRefs<"RoomEditTabs_room" | "RoomSidebar_room">;
  } | null;
};
export type RoomEditMainMutation = {
  response: RoomEditMainMutation$data;
  variables: RoomEditMainMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locale",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoomEditMainMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Room",
        "kind": "LinkedField",
        "name": "updateRoom",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoomEditTabs_room"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoomSidebar_room"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoomEditMainMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Room",
        "kind": "LinkedField",
        "name": "updateRoom",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "MediaConnection",
            "kind": "LinkedField",
            "name": "media",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "media(first:2147483647)"
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "capacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RoomProperty",
            "kind": "LinkedField",
            "name": "properties",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "etgKey",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Text",
            "kind": "LinkedField",
            "name": "name",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TextTranslationConnection",
                "kind": "LinkedField",
                "name": "translations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TextTranslationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TextTranslation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "string",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Text",
            "kind": "LinkedField",
            "name": "descriptionText",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TextBlockConnection",
                "kind": "LinkedField",
                "name": "blocks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TextBlockEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TextBlock",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "data",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "MediaConnection",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Media",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "S120X120"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "externalUrl",
                            "storageKey": "externalUrl(size:\"S120X120\")"
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "w262"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "src",
                            "storageKey": "src(size:\"w262\")"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "media(first:2147483647)"
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "MediaEditor_mediable_media",
                "kind": "LinkedHandle",
                "name": "media"
              }
            ],
            "type": "Mediable",
            "abstractKey": "__isMediable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "af4211a149b36310da507578032841ec",
    "id": null,
    "metadata": {},
    "name": "RoomEditMainMutation",
    "operationKind": "mutation",
    "text": "mutation RoomEditMainMutation(\n  $id: ID!\n  $input: UpdateRoomInput!\n) {\n  updateRoom(id: $id, input: $input) {\n    ...RoomEditTabs_room\n    ...RoomSidebar_room\n    id\n  }\n}\n\nfragment EditorJsField_text on Text {\n  id\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        id\n      }\n    }\n  }\n  ...EditorToolbar_text\n}\n\nfragment EditorLanguageButton_text on Text {\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        id\n      }\n    }\n  }\n}\n\nfragment EditorToolbar_text on Text {\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        ...EditorTranslateButton_textBlock\n        id\n      }\n    }\n  }\n  ...EditorLanguageButton_text\n}\n\nfragment EditorTranslateButton_textBlock on TextBlock {\n  id\n  data\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment MediaEditorPreviews_media on MediaConnection {\n  edges {\n    node {\n      id\n      ...MediaEditorThumb_media\n    }\n  }\n}\n\nfragment MediaEditorSort_media on MediaConnection {\n  edges {\n    node {\n      id\n    }\n  }\n}\n\nfragment MediaEditorThumb_media on Media {\n  id\n  ...MediaThumb_media\n}\n\nfragment MediaEditor_mediable on Mediable {\n  __isMediable: __typename\n  id\n  media(first: 2147483647) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...MediaEditorPreviews_media\n    ...MediaEditorSort_media\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MediaThumb_media on Media {\n  type\n  externalUrl(size: S120X120)\n  src(size: w262)\n}\n\nfragment RoomEditMainGeneral_room on Room {\n  name {\n    ...TranslatableTextField_text\n    id\n  }\n}\n\nfragment RoomEditMain_room on Room {\n  id\n  capacity\n  description\n  properties {\n    id\n    name\n    icon\n    etgKey\n  }\n  name {\n    ...useTranslatableField_text\n    id\n  }\n  descriptionText {\n    ...EditorJsField_text\n    ...useEditorJsField_text\n    id\n  }\n  ...RoomEditMainGeneral_room\n}\n\nfragment RoomEditTabs_room on Room {\n  media(first: 2147483647) {\n    pageInfo {\n      total\n    }\n  }\n  ...RoomEditMain_room\n  ...MediaEditor_mediable\n}\n\nfragment RoomSidebar_room on Room {\n  ...EntitySidebar_entity\n}\n\nfragment TranslatableTextFieldInput_text on Text {\n  translations {\n    edges {\n      node {\n        locale\n        ...TranslatableTextFieldTranslateButton_textTranslation\n        id\n      }\n    }\n  }\n}\n\nfragment TranslatableTextFieldTranslateButton_textTranslation on TextTranslation {\n  id\n  string\n}\n\nfragment TranslatableTextField_text on Text {\n  ...TranslatableTextFieldInput_text\n}\n\nfragment useEditorJsField_text on Text {\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        id\n      }\n    }\n  }\n}\n\nfragment useTranslatableField_text on Text {\n  translations {\n    edges {\n      node {\n        locale\n        string\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d495b26ae3cf013f3fee58f03dee4382";

export default node;
